/**
 * HostTermsPage - Host Terms of Service
 */

import React from 'react';
import { PublicLayout, Container } from '../../components/layout';

export const HostTermsPage: React.FC = () => {
  return (
    <PublicLayout>
      <Container className="py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Host Terms of Service</h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              Last updated: January 2024
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Introduction</h2>
            <p className="text-gray-600 mb-4">
              Welcome to DARAK. These Host Terms of Service govern your use of our platform as a property host. By listing your property on DARAK, you agree to these terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Host Responsibilities</h2>
            <p className="text-gray-600 mb-4">
              As a host on DARAK, you agree to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Provide accurate and complete information about your property</li>
              <li>Maintain your property in a clean and safe condition</li>
              <li>Respond to booking requests within 24 hours</li>
              <li>Honor confirmed reservations</li>
              <li>Comply with all local laws and regulations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Listing Requirements</h2>
            <p className="text-gray-600 mb-4">
              All listings must include accurate photos, descriptions, pricing, and availability information. Misleading information may result in listing removal.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Payments</h2>
            <p className="text-gray-600 mb-4">
              Payments are processed securely through Stripe. Guests pay the listed price with no additional fees. DARAK retains a 10% platform commission from each booking. Host payouts (90% of the booking total) are available after guest checkout and can be withdrawn via Whish Money or bank transfer.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Cancellation Policy</h2>
            <p className="text-gray-600 mb-4">
              Hosts can choose from flexible, moderate, or strict cancellation policies. Repeated host cancellations may result in penalties or account suspension.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Host Protection</h2>
            <p className="text-gray-600 mb-4">
              DARAK provides Host Protection coverage up to $1,000,000 for property damage during guest stays, subject to terms and conditions.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Contact</h2>
            <p className="text-gray-600 mb-4">
              For questions about these terms, contact us at hello@kodefoundry.com
            </p>
          </div>
        </div>
      </Container>
    </PublicLayout>
  );
};

export default HostTermsPage;
